import { _endpointWarehouseCompany } from "../../utils/provider";
import {
  _createRequest,
  _getFilter,
  _fetch,
  _normalizeSearchText,
} from "../../utils/helper";
const endpoint = (rawProps) => {
  const { type } = rawProps;
  // Never mutate the caller's params/filter objects in place — `filter`
  // here can be the exact same object react-admin's <Filter> form is still
  // holding onto in its own Redux state. Renaming/deleting keys on that
  // shared object behind react-admin's back corrupts it (confirmed on
  // Agency Warehouse: clearing the search box no longer removed the
  // server-side filter, since the renamed key was invisible to the form).
  const params = { ...rawProps.params, filter: { ...(rawProps.params && rawProps.params.filter) } };
  // The search box's <TextInput source> is intentionally dot-free
  // ("warehouse_search", see warehouseCompanies/list.js) because
  // react-admin's <Filter> form (react-final-form) treats a dotted source
  // as a nested path, not a literal flat key — so remap it here to the
  // real filter column. Same fix already verified on Agency Warehouse.
  if (typeof params.filter["warehouse_search"] === "string") {
    params.filter["p.name_search"] = params.filter["warehouse_search"];
    delete params.filter["warehouse_search"];
  }
  // Search box (Admin > Kho hàng tổng) filters against the pre-normalized
  // products.name_search column (see migration 1058), so the search term
  // must be normalized the same way before being sent. An empty/
  // whitespace-only value is removed entirely rather than sent as an
  // ILIKE '%%' (matches-everything but pointless) condition.
  if (typeof params.filter["p.name_search"] === "string") {
    const trimmed = params.filter["p.name_search"].trim();
    if (trimmed) {
      params.filter["p.name_search"] = _normalizeSearchText(trimmed);
    } else {
      delete params.filter["p.name_search"];
    }
  }
  const sort = !Array.isArray(params.sort) ? [params.sort] : params.sort;
  switch (type) {
    case "manyReference":
    case "many": {
      //many
      const { target = "id" } = params;
      if (params.ids) {
        params.filter = {
          ...params.filter,
          [target]: params.ids,
        };
      }
      params.pagination = {
        ...params.pagination,
        perPage: (params.ids || []).length || 10,
      };
      return _fetch(
        _createRequest(_endpointWarehouseCompany.statistic, true, {
          filter: _getFilter(params, { status: "eq", agency_id: "in" }),
        })
      );
    }
    case "all": {
      const getAll = (page = 1, data = []) => {
        const perPage = 100;
        params.pagination = {
          perPage: perPage,
          page: page,
        };

        return _fetch(
          _createRequest(_endpointWarehouseCompany.statistic, true, {
            filter: _getFilter(params, { status: "eq", agency_id: "in" }),
          })
        ).then((res) => {
          if (res.total === undefined || res.total <= page * perPage) {
            return {
              ...res,
              data: [...data, ...res.data],
            };
          } else {
            return getAll(page + 1, [...data, ...res.data]);
          }
        });
      };
      return getAll(1);
    }
    default: {
      //list
      return _fetch(
        _createRequest(_endpointWarehouseCompany.statistic, true, {
          filter: _getFilter(
            {
              ...params,
              sort: [...sort, { field: "cw.id", order: "ASC" }],
            },
            { status: "eq", quantity: "lt" }
          ),
        })
      );
    }
  }
};

export default endpoint;
